import globalMessage from "@/utils/globalMessage";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Banner, Navigation, ProfilePage } from './Profile.styles.js';
import Container from "@components/Container/Container.js";
import login from '@assets/images/login.jpg';
import { Button, Card, Tabs } from "antd";
import _ from "lodash";

import { api } from "@redux/api";
import { UnlockOutlined } from "@ant-design/icons";
import UserProfileForm from './UserProfileForm.js';

const { TabPane } = Tabs;

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [],
        }
    }

    componentDidMount() {
        let columns = [
            {
                title: 'Id',
                dataIndex: 'id',
                width: '10%',
            },
            {
                title: 'Username',
                dataIndex: 'username',
                width: '10%',
                editable: true,
            },
        ]
        this.setState({
            columns
        })
    }

    handleResetPassword = (e) => {

        let email = _.get(this.props.auth, 'email')

        this.setState({
            isLoading: true
        })
        api.forgetpassword(email).then(res => {
            this.setState({
                isLoading: false
            })
            return globalMessage['success']({
                message: 'Success',
                description: 'Password reset successfully, please check your email', placement: 'topLeft'
            });
        })

    }

    render() {

        return (
            <ProfilePage>
                <Banner
                    className="profile-banner"
                    style={{ backgroundImage: `url(${login})` }}
                >
                    <Container className="container">
                    </Container>
                </Banner>

                <Navigation className="navigation">
                    <Container className="profile-container">
                        <Tabs defaultActiveKey="1" centered>
                            <TabPane tab="Personal Settings" key="1">
                                <Card
                                    bordered={false}
                                    className="profile-card"
                                    title={
                                        <div className="profile-card-actions">
                                            <Button
                                                type='primary'
                                                key="1"
                                                onClick={this.handleResetPassword}
                                                icon={<UnlockOutlined />}
                                                className="profile-reset-button"
                                            >
                                                Reset Password
                                            </Button>
                                        </div>
                                    }
                                >
                                        <UserProfileForm />
                                </Card>
                            </TabPane>
                        </Tabs>
                    </Container>
                </Navigation>
            </ProfilePage>
        );
    }
}

const mapStateToProps = state => {
    return {
        auth: state.Auth,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Profile);
